// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cliente-reajuste-igpm-historico-modal {
  width: min(1600px, 96vw);
}
.cliente-reajuste-igpm-historico-modal .uk-accordion-title {
  font-size: 18px;
}
.cliente-reajuste-igpm-historico-itens-table {
  min-width: 1320px;
}
.cliente-reajuste-igpm-historico-itens-table td:nth-child(4) {
  min-width: 230px;
}
.cliente-reajuste-igpm-historico-itens-table td:nth-child(5) {
  min-width: 260px;
}
.cliente-reajuste-igpm-historico-de-para {
  display: grid;
  gap: 2px;
  padding: 4px 0;
}
.cliente-reajuste-igpm-historico-de-para span {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.cliente-reajuste-igpm-historico-modal [data-igpm-historico-estado],
.cliente-reajuste-igpm-historico-modal [data-igpm-itens][aria-busy="true"] {
  padding: 16px;
  background: #f8f8f8;
  text-align: center;
}
.cliente-reajuste-igpm-historico-paginacao {
  flex-wrap: wrap;
  gap: 8px 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/cadastros/clienteReajusteIgpm/historico.less"],"names":[],"mappings":"AAAA;EACI,wBAAA;AACJ;AAFA;EAIQ,eAAA;AACR;AAGA;EACI,iBAAA;AADJ;AAAA;EAGsB,gBAAA;AAAtB;AAHA;EAIsB,gBAAA;AAEtB;AACA;EACI,aAAA;EACA,QAAA;EACA,cAAA;AACJ;AAJA;EAMQ,mBAAA;EACA,kCAAA;AACR;AAGA;;EAEQ,aAAA;EACA,mBAAA;EACA,kBAAA;AADR;AAKA;EACI,eAAA;EACA,UAAA;AAHJ","sourcesContent":[".cliente-reajuste-igpm-historico-modal {\n    width: min(1600px, 96vw);\n\n    .uk-accordion-title {\n        font-size: 18px;\n    }\n}\n\n.cliente-reajuste-igpm-historico-itens-table {\n    min-width: 1320px;\n\n    td:nth-child(4) { min-width: 230px; }\n    td:nth-child(5) { min-width: 260px; }\n}\n\n.cliente-reajuste-igpm-historico-de-para {\n    display: grid;\n    gap: 2px;\n    padding: 4px 0;\n\n    span {\n        white-space: nowrap;\n        font-variant-numeric: tabular-nums;\n    }\n}\n\n.cliente-reajuste-igpm-historico-modal {\n    [data-igpm-historico-estado], [data-igpm-itens][aria-busy=\"true\"] {\n        padding: 16px;\n        background: #f8f8f8;\n        text-align: center;\n    }\n}\n\n.cliente-reajuste-igpm-historico-paginacao {\n    flex-wrap: wrap;\n    gap: 8px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
